// extracted by mini-css-extract-plugin
module.exports = {"root":"Title_root__wBnqm","visible":"Title_visible__Of66j","positioner":"Title_positioner__aMY_s","subTitle":"Title_subTitle__BlY7p"};